import { LocaleSettingsView } from '@today/ui-domain'
import { Navigate, useParams } from 'react-router-dom'
import { useLocaleSettings } from '@/hooks/products/useLocaleSettings'
import { useTenantSlug } from '@/hooks/products/useTenantLocales'
import { ForbiddenPage } from '@/pages/errors/Forbidden'

/** `/t/:slug/admin/locale-settings` — the tenant's locale settings (TO-416 product-admin-ui REQ-009). */
export function LocaleSettingsPage() {
	const { slug = '' } = useParams()
	const { forbidden, loading, ...view } = useLocaleSettings(slug)
	if (forbidden) return <ForbiddenPage />
	return loading ? null : <LocaleSettingsView {...view} />
}

/** `/admin/locale-settings` — the navigation entry: resolve the viewer's tenant slug, then open its screen. */
export function LocaleSettingsRedirect() {
	const { slug, isError } = useTenantSlug()
	if (isError) return <ForbiddenPage />
	return slug ? <Navigate to={`/t/${slug}/admin/locale-settings`} replace /> : null
}
